var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 519,
    height: 272,
    viewBox: "0 0 519 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.5 272L34.7664 87.5L484.234 87.5L259.5 272Z",
    fill: "url(#paint0_radial_162_1371)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M494.9 67C494.9 76.061 488.347 84.7162 476.438 92.6068C464.533 100.495 447.3 107.602 425.997 113.573C383.391 125.513 324.525 132.9 259.5 132.9C194.475 132.9 135.609 125.513 93.0033 113.573C71.6996 107.602 54.4667 100.495 42.562 92.6068C30.6534 84.7162 24.1 76.061 24.1 67C24.1 57.939 30.6534 49.2838 42.562 41.3932C54.4667 33.5052 71.6996 26.3977 93.0033 20.4272C135.609 8.48668 194.475 1.1 259.5 1.1C324.525 1.1 383.391 8.48668 425.997 20.4272C447.3 26.3977 464.533 33.5052 476.438 41.3932C488.347 49.2838 494.9 57.939 494.9 67Z",
    fill: "url(#paint1_linear_162_1371)",
    stroke: "#E5E5E5",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M362.675 7.67124C320.256 1.87724 272.604 -0.211698 225.898 1.67527C179.192 3.56224 135.586 9.33808 100.733 18.2539C65.8804 27.1698 41.3889 38.8144 30.4339 51.678C19.4789 64.5417 22.5658 78.031 39.2943 90.397C56.0228 102.763 85.6214 113.435 124.252 121.031C162.883 128.626 208.765 132.793 255.949 132.992C303.132 133.192 349.442 129.414 388.872 122.149C428.303 114.884 459.036 104.466 477.088 92.2474",
    stroke: "url(#paint2_angular_162_1371)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_162_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(253 272) rotate(-47.5218) scale(273.208 576.402)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8DD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_162_1371",
    x1: 35,
    y1: 33,
    x2: 488,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44EFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8DD2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_162_1371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(250.544 67) rotate(90) scale(66 226.544)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185951,
    stopColor: "#7C79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599259,
    stopColor: "#7572FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.883cad25a1509e761c0fdefd1059b2c2.svg";
export { ForwardRef as ReactComponent };